import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormTextField from '../../form/FormTextField';
import FormAutocompleteField from '../../form/FormAutocompleteField';
import { Field } from 'react-final-form';

const required = value => value ? undefined : 'Pole jest wymagane';

class TechnikaItAddress extends React.Component {
  render() {
    const { voterRequiredData, streetsAutocompleteData, change, addressRestrictedToCities } = this.props;
    const cities = _.uniqBy(streetsAutocompleteData, s => s.cityId)
      .filter(s => !addressRestrictedToCities.length || addressRestrictedToCities.includes(s.cityName))
      .map(s => ({ id: s.cityId, name: s.cityName }));
    return (
      <React.Fragment>
        <div>
          <Field
            name="respondent.cityId"
            component={FormAutocompleteField}
            label="Miejscowość"
            placeholder="Miejscowość"
            validate={voterRequiredData.addressOptional ? undefined : required}
            autocompleteData={cities}
            onChange={(_, value) => {
              change('respondent.addressId', null);
              change('respondent.address', null);

              if (value) {
                const selectedCity = cities.find(l => l.id === value);
                change('respondent.city', selectedCity.name);
              } else {
                change('respondent.city', null);
              }
            }}
          />
        </div>
        <div>
          <Field
            name="respondent.addressId"
            component={FormAutocompleteField}
            label="Adres"
            placeholder="Adres"
            validate={
              voterRequiredData.addressOptional || (this.props.cityId && !streetsAutocompleteData.filter(s => s.cityId === this.props.cityId).every(s => s.name))
              ? undefined
              : required
            }
            autocompleteData={streetsAutocompleteData.filter(s => s.cityId === this.props.cityId)}
            onChange={(_, value) => {
              if (value) {
                const selectedStreet = streetsAutocompleteData.find(s => s.id === value);
                change('respondent.address', selectedStreet.name);
              } else {
                change('respondent.address', null);
              }
            }}
          />
          <Field
            name="respondent.number"
            component={FormTextField}
            label="Numer domu"
            validate={voterRequiredData.addressOptional ? undefined : required}
            style={{ marginRight: 10, width: 110 }}
          />
          <Field
            name="respondent.localNumber"
            component={FormTextField}
            label="Numer lokalu"
            style={{ width: 110 }}
          />
        </div>
      </React.Fragment>);
  }
}

TechnikaItAddress.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  streetsAutocompleteData: PropTypes.array.isRequired,
  change: PropTypes.func.isRequired,
  cityId: PropTypes.number,
  addressRestrictedToCities: PropTypes.array.isRequired,
};

export default TechnikaItAddress;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/responderVerification/TechnikaItAddress.js